
import Vue from "vue";
import $ from "jquery";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action, State, Getter } from "vuex-class";
import { Watch } from "vue-property-decorator";

@Component({
  filters,
})
export default class JobFairCandidateList extends Vue {
  /* VUEX */

  // ACTION
  @Action("actionJobFairCandidateList", { namespace: "job" })
  private actionJobFairCandidateList: any;
  @Action("actionPaginationJobFairCompanyJobCandidate", { namespace: "job" })
  private actionPaginationJobFairCompanyJobCandidate: any;

  // STATE
  @State("job_fair_candidate", { namespace: "job" })
  private job_fair_candidate: any;
  @State("job_fair", { namespace: "job" })
  private job_fair: any;


  public get candidateList() : any[] {
    if(this.job_fair.id ) return this.job_fair_candidate.results
    return []
  }

  @Watch("$router") OnChangesRoute(){
    this.job_fair_candidate = new JobFairCandidateList
  }


  /* INITIALIZATION */
  private onLoad: boolean = false;
  private activePage: number = 1;

  private created() {
    // RESIZE RESPONSIVE CARD
    this.resizeTab();
    setTimeout(() => {
      this.listenInfinityScroll();
    }, 1000);
  }

  private mounted() {
    this.resizeTab();
  }

  /* METHOD */

  private listenInfinityScroll() {
    const self = this;
    $(document).ready(function () {
      // INFINITE SCROLL PAGINATION
      const tableJobfairCandidate = $("#TableJobFairCandidateList");
      if (tableJobfairCandidate.length > 0) {
        // Only Debug/Development
        // console.log("listened infinity scroll");
        $("#TableJobFairCandidateList").scroll(function () {
          const scrollTop: number = $(this).scrollTop() ?? 0;
          // Only Debug/Development
          // console.log("Scroll Top : ", scrollTop);

          const innerHeight: number = $(this).innerHeight() ?? 0;
          // Only Debug/Development
          // console.log("Inner Height : ", innerHeight);

          const scrollHeight: number = $(this)[0].scrollHeight;

          // Only Debug/Development
          // const topAndInner = scrollTop + innerHeight;
          // console.log("Top & Inner : ", topAndInner);

          // Only Debug/Development
          // console.log("Scroll Height : ", scrollHeight);

          if (scrollTop + innerHeight >= scrollHeight) {
            if (!self.onLoad) {
              if (self.job_fair_candidate.results.length === 0) {
                return;
              }
              if (self.onLoad) {
                return;
              }
              if (self.job_fair_candidate.next) {
                self.activePage++;
                self.clickPage(self.activePage, self.job_fair_candidate.next);
              }
            }
          }
        });
      }
    });
  }

  private clickCandidate(candidate: any) {
    this.$router.push({
      name: "jobsFairCandidate",
      params: { id: this.job_fair.id, candidate_id: candidate.id },
    });
  }

  private resizeTab() {
    const width =
      ($(document).width() as number) -
      ($("#cardProfile").width() as number) -
      150;
    $(".tab-content").css("max-width", `${width}px`);
    $(window).on("resize", () => {
      const width =
        ($(document).width() as number) -
        ($("#cardProfile").width() as number) -
        150;
      $(".tab-content").css("max-width", `${width}px`);
    });
  }

  private clickPage(page: number, url: string) {
    if (url) {
      this.actionPaginationJobFairCompanyJobCandidate({
        params: { url, page, params: null },
        success: (data: any) => {
          // TODO
        },
      });
    } else {
      this.actionJobFairCandidateList({
        params: null,
        success: (data: any) => {
          // TODO
        },
      });
    }
  }

  private dummyData: any[] = [
    {
      id: 1,
      full_name: "Agung Tirto",
      avatar: require("@/assets/Photo/Student/Agung Tirto.png"),
      school_name: "Universitas Gajah Mada",
      major: "Teknik Informatika",
      join_date: "2020-12-07",
      total_applying: 5,
      graduation: 2013,
    },
    {
      id: 2,
      full_name: "Andi Santoso",
      avatar: require("@/assets/Photo/Student/Andi Santoso.jpg"),
      school_name: "Universitas Podomoro",
      major: "Desain Grafis",
      join_date: "2020-12-06",
      total_applying: 15,
      graduation: 2019,
    },
    {
      id: 3,
      full_name: "Andin Widiana",
      avatar: require("@/assets/Photo/Student/Andin Widiana.jpg"),
      school_name: "Universitas Indonesia",
      major: "Ilmu Komputer",
      join_date: "2020-12-05",
      total_applying: 30,
      graduation: 2011,
    },
    {
      id: 4,
      full_name: "Citra Angelina",
      avatar: require("@/assets/Photo/Student/Citra Angelina.jpg"),
      school_name: "Universitas Surabaya",
      major: "Ilmu Komputer",
      join_date: "2020-12-04",
      total_applying: 5,
      graduation: 2018,
    },
    {
      id: 5,
      full_name: "Cynthia Yolanda",
      avatar: require("@/assets/Photo/Student/Cynthia Yolanda.jpg"),
      school_name: "Universitas Jakarta",
      major: "Marketing",
      join_date: "2020-12-03",
      total_applying: 15,
      graduation: 2014,
    },
    {
      id: 6,
      full_name: "Dimas Bagaskara",
      avatar: require("@/assets/Photo/Student/Dimas Bagaskara.jpg"),
      school_name: "Universitas Madura",
      major: "Desain Grafis",
      join_date: "2020-12-02",
      total_applying: 10,
      graduation: 2018,
    },
    {
      id: 7,
      full_name: "Nadia Bella",
      avatar: require("@/assets/Photo/Student/Nadia Bella.jpg"),
      school_name: "Universitas Bina Nusantara",
      major: "Desain Grafis",
      join_date: "2020-12-01",
      total_applying: 20,
      graduation: 2019,
    },
  ];
}
